import React from 'react';

const Icon = ({ name, size = 20 }) => {
  const base = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', width: size, height: size, 'aria-hidden': true };
  switch (name) {
    case 'packet':
      return <svg {...base}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" /><path d="M14 2v6h6" /><path d="M9 13h6M9 17h6" /></svg>;
    case 'badge':
      return <svg {...base}><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2" /><path d="M15 8h4M15 12h4M7 16h10" /></svg>;
    case 'syringe':
      return <svg {...base}><path d="m18 2 4 4" /><path d="m17 7 3-3" /><path d="M19 9 8.7 19.3a2.4 2.4 0 0 1-3.4 0l-.6-.6a2.4 2.4 0 0 1 0-3.4L15 5" /><path d="m9 11 4 4" /><path d="m5 19-3 3" /></svg>;
    case 'person':
      return <svg {...base}><circle cx="12" cy="8" r="4" /><path d="M4 21v-1a7 7 0 0 1 14 0v1" /></svg>;
    case 'trophy':
      return <svg {...base}><path d="M8 21h8" /><path d="M12 17v4" /><path d="M7 4h10v5a5 5 0 0 1-10 0Z" /><path d="M7 6H4a1 1 0 0 0-1 1c0 2.2 1.8 4 4 4" /><path d="M17 6h3a1 1 0 0 1 1 1c0 2.2-1.8 4-4 4" /></svg>;
    case 'history':
      return <svg {...base}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>;
    default:
      return null;
  }
};

const ITEMS = [
  { tab: 'Packet Builder', icon: 'packet', color: 'var(--cr-primary-mid)', title: 'Packet Builder', sub: 'Bundle and send show documents' },
  { tab: 'Shows', icon: 'trophy', color: 'var(--cr-pink)', title: 'Shows and entries', sub: 'Import prize lists, build show entries' },
  { tab: 'Credentials', icon: 'badge', color: 'var(--cr-green)', title: 'Credentials', sub: 'Cards, Coggins, registrations' },
  { tab: 'USEF Vaccine Form', icon: 'syringe', color: 'var(--cr-amber)', title: 'USEF vaccine form', sub: 'Build the vaccination record' },
  { tab: 'Secretaries', icon: 'person', color: 'var(--cr-blue)', title: 'Secretaries', sub: 'Saved show contacts' },
  { tab: 'Sent History', icon: 'history', color: 'var(--cr-purple)', title: 'Sent history', sub: 'Every packet you have emailed' }
];

export default function ShowCenterHub({ onOpen }) {
  return (
    <div>
      {ITEMS.map(item => (
        <button
          key={item.tab}
          onClick={() => onOpen(item.tab)}
          className="card"
          style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', cursor: 'pointer', background: 'var(--bg-primary)' }}
        >
          <div style={{ width: 42, height: 42, borderRadius: 12, background: item.color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name={item.icon} size={22} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-primary)' }}>{item.title}</div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{item.sub}</div>
          </div>
          <svg viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18" aria-hidden="true"><path d="m9 6 6 6-6 6" /></svg>
        </button>
      ))}
    </div>
  );
}
